import React from 'react';

const Button = ({
    children,
    type = 'button',
    onClick,
    disabled = false,
    variant = 'primary',
    size = 'default',
    loading = false,
    className = '',
    ...props
}) => {
    const baseClasses = `
    flex min-w-[150px] max-w-[350px] cursor-pointer items-center justify-center 
    overflow-hidden rounded-xl h-12 px-5 text-sm font-medium leading-normal 
    tracking-[0.015em] transition-colors disabled:opacity-50 disabled:cursor-not-allowed
  `;

    const variantClasses = {
        primary: 'bg-[#eaedfa] text-[#121317] hover:bg-[#dde1f5]',
        secondary: 'bg-[#f1f1f4] text-[#121317] hover:bg-[#e8e9ed]',
        outline: 'bg-gray-50 border border-[#dddee4] text-[#121317] hover:bg-gray-200',
        danger: 'bg-red-500 text-white hover:bg-red-600 border border-red-500',
    };

    const sizeClasses = {
        small: 'h-8 px-3 text-xs',
        default: 'h-10 px-4 text-sm',
        large: 'h-12 px-6 text-base',
    };

    return (
        <button
            type={type}
            className={`${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${className}`}
            onClick={onClick}
            disabled={disabled || loading}
            {...props}
        >
            {loading ? (
                <div className="flex items-center gap-2">
                    <div className="w-4 h-4 border-2 border-current border-t-transparent rounded-full animate-spin"></div>
                    <span className="truncate">Loading...</span>
                </div>
            ) : (
                <span className="truncate">{children}</span>
            )}
        </button>
    );
};

export default Button;
